/*global VeloxViewController*/

var mainController = require("../main/mainController") ;

var deviceFrontController = new VeloxViewController({
    directory : "views/device",
    name: "deviceFront",
    route: "device-view"
}) ;

deviceFrontController.prepareDataOnEnter = function(data, callback){
    this.api.api.multiread({
        device: {pk: data, joinFetch: [
                { 
                    otherTable: "velox_binary", 
                    thisField: "d_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"device"}
                },
                {otherTable: "link_part_device", type:"2many", name: "parts", orderBy: "p_ref", joins: [
                    {otherTable: "part", flatten: true, joins: [
                        { 
                            otherTable: "velox_binary", 
                            thisField: "p_ref", otherField: "table_uid", name: "binary", joinSearch: {table_name:"part"}
                        },       
                        { 
                            otherTable: "link_part_part", type:"2one", name: "subpart", thisField: "p_ref", otherField: "part_parent"
                        }       
                    ]}
                ] },
                {otherTable: "exploded", joins:[
                    { 
                        otherTable: "velox_binary", 
                        thisField: "e_id", otherField: "table_uid", name: "binary", joinSearch: {table_name:"exploded"}
                    },
                    {   otherTable: "part_exploded_position", name:"positions", type: "2many" }
                ] },
        ]}
    }, function(err, reads){
        if(err){ return callback(err) ;}

        var device = reads.device ;

        var partsByRef = {} ;
        device.parts.forEach(function(p){
            partsByRef[p.p_ref] = p ;
        }) ;

        if(device.exploded){
            device.exploded.positions.forEach(function(pos){
                if(partsByRef[pos.p_ref]){
                    partsByRef[pos.p_ref].position = pos ;
                    pos.numbers = pos.pos_number?pos.pos_number.split(",").map(function(n){ return {number : n} ;}).reverse():[] ;
                }
            }) ;
        }


        device.parts = device.parts.sort(function(p1, p2){
            var posNumber1 = p1.position ? ""+p1.position.pos_number: "" ;
            var posNumber2 = p2.position ? ""+p2.position.pos_number: "" ;
            if(!posNumber1){ posNumber1 = "999999" ;}
            if(!posNumber2){ posNumber2 = "999999" ;}
            posNumber1 = posNumber1.split(",")[0] ;
            if(!posNumber1){ posNumber1 = "999999" ;}
            posNumber1 = Number(posNumber1) ;
            posNumber2 = posNumber2.split(",")[0] ;
            if(!posNumber2){ posNumber2 = "999999" ;}
            posNumber2 = Number(posNumber2) ;
            if(posNumber1 > posNumber2){
                return 1 ;
            } else if(posNumber1 < posNumber2){
                return -1;
            } else {
                if(p1.p_ref > p2.p_ref){
                    return 1 ;
                }else{
                    return -1 ;
                }
            }
        }) ;

        if(device.exploded && device.exploded.binary){
            this.api.readBinary.url(device.exploded.binary, function(err, urlSvg){
                if(err){ return callback(err) ;}
                var xhr = new XMLHttpRequest();
                xhr.open("GET", urlSvg);
                xhr.onreadystatechange = (function () {
                    if (xhr.readyState === 4){
                        var responseResult = xhr.responseText ;
                        if(xhr.status >= 200 && xhr.status < 300) {
                            device.exploded.svg = responseResult ;
                            callback(null, device);
                        } else {
                            callback(responseResult||xhr.status);
                        }
                    } 
                }).bind(this);
                xhr.send();
            })  ;
        }else{
            callback(null, device) ;
        }

    }.bind(this)) ;
} ;

deviceFrontController.onAddList = function(ev){
    var part = ev.data.data ;
    mainController.addPartToList(part) ;
} ;


module.exports = deviceFrontController ;